import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip as TooltipMui } from '@mui/material';
import './Tooltip.module.scss';
export function Tooltip(props) {
    return _jsx(TooltipMui, Object.assign({}, props, { children: props.children }));
}
